export default __webpack_public_path__ + "media/MATCHPERCENTAGE.934cffb05b89a760069807e50afdaffc.mp4";